import styles from './Photo.module.css';

const Photo = props => {
  return (
    <img className={styles.image} id={props.id} key={props.id} src={props.image} alt={props.alt} />
  );
};

export default Photo;